import {Dispatch, SetStateAction} from 'react';

interface RadioOption<T extends string | number> {
  title: string;
  description?: string;
  value: T;
}

interface RadioGroupListProps<T extends string | number> {
  title: string;
  options: readonly RadioOption<T>[];
  value: T;
  setValue: Dispatch<SetStateAction<T>>;
  name?: string;
  required?: boolean;
}

const RadioGroupList = <T extends string | number>({
  title,
  options,
  value,
  setValue,
  name = 'radio-group',
  required = false,
}: RadioGroupListProps<T>) => {
  if (!options.length) return null;

  return (
    <div className="space-y-3">
      <span className="font-medium text-gray-700 text-md">
        {title}
        {required && <span className="mr-1 text-lg text-red-600">*</span>}
      </span>

      <div className="space-y-4">
        {options.map(option => (
          <label
            key={option.value}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="radio"
              name={name}
              checked={value === option.value}
              onChange={() => setValue(option.value)}
              className="accent-farm-shop-500"
            />

            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-800">{option.title}</span>
              {option.description && (
                <span className="text-sm text-gray-600">
                  {option.description}
                </span>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroupList;
